import React, { useContext, useState } from "react";
import styled from "styled-components";
import ArrowBack from "../../../assets/images/arrow-left.png";
import deleteIcon from "../../../assets/images/trash.png";
import Vector from "../../../assets/images/chevron-up0.svg";
import Visa from "../../../assets/images/icon-visa.png";
import LayoutContext from "../../../contexts/LayoutContext";
import PaymentMethodsComponent from "./PaymentMethodsComponent";
import StripeInputs from "../forms/stripePayments/StripeInputs";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import * as Library from "../../../utils/Library";
import UserContext from "../../../contexts/UserContext";
import { cardType, paymentMethods, paymentTypeNames, processPaymentData } from "../../../utils/helperFunctions";
import MasterCard from "../../../assets/images/MasterCard.png";
import plus from "../../../assets/images/plus.png";
import klarna from "../../../assets/images/Klarna.png";
import applePay from "../../../assets/images/ApplePay.png";
import googlePay from "../../../assets/images/GooglePay.png";
import { paymentPopUptValidation } from "../../../utils/payments";

const Styles = styled.div`
    .frame-313515,
    .frame-313515 * {
        box-sizing: border-box;
    }
    .frame-313515 {
        display: flex;
        flex-direction: column;
        gap: 20px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011190 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011176 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .add-credit-or-debit-card {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--heading-4-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--heading-4-font-size, 14px);
        line-height: var(--heading-4-line-height, 20px);
        font-weight: var(--heading-4-font-weight, 600);
        position: relative;
        align-self: stretch;
    }
    .frame-313373 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .input-field {
        background: var(--surface-surface-secondary, #121212);
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        box-shadow: var(--dropdown-input-field-box-shadow, 0px 0px 15px 0px rgba(0, 0, 0, 0.25));
    }
    .label {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: var(--label-medium-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--label-medium-font-size, 14px);
        line-height: var(--label-medium-line-height, 14px);
        font-weight: var(--label-medium-font-weight, 400);
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .input-field-credit-card {
        background: var(--surface-surface-secondary, #121212);
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 8px 16px 8px 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        box-shadow: var(--dropdown-input-field-box-shadow, 0px 0px 15px 0px rgba(0, 0, 0, 0.25));
    }
    .frame-29438 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 30px;
        position: relative;
    }
    .credit-card-02 {
        flex-shrink: 0;
        height: 24px;
        position: relative;
        overflow: visible;
    }
    .card-number {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: var(--label-medium-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--label-medium-font-size, 14px);
        line-height: var(--label-medium-line-height, 14px);
        font-weight: var(--label-medium-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .mm-yy {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 14px);
        line-height: var(--subtitle-2-line-height, 24px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
    }
    .cvc {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 14px);
        line-height: var(--subtitle-2-line-height, 24px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
    }
    .btn-lg-solid {
        background: var(--salmon, #f7665f);
        border-radius: 5px;
        opacity: 0.2;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 371px;
        height: 48px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
    }
    .frame-29590 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .plus {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-medium-regular-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-medium-regular-font-size, 14px);
        line-height: var(--button-text-medium-regular-line-height, 24px);
        font-weight: var(--button-text-medium-regular-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .frame-1000011192 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }

    .default {
        color: var(--color-emphasis, #9cf9cf);
        text-align: left;
        font-family: var(--label-xsmall-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--label-xsmall-font-size, 8px);
        line-height: var(--label-xsmall-line-height, 8px);
        font-weight: var(--label-xsmall-font-weight, 600);
        position: relative;
        height: 20px;
        width: 40px;
        display: flex;
        align-items: center;
        border: 1px solid var(--wrap-wrap-emphasis, rgba(156, 249, 207, 0.1));
        border-radius: 5px;
        justify-content: center;
    }
    .frame-1000011193 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .location-indicator {
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 372px;
        position: relative;
    }
    .frame-29614 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        position: relative;
    }
    .frame-1000011189 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .group-1000011163 {
        flex-shrink: 0;
        width: 37px;
        height: 20px;
        position: relative;
        overflow: visible;
        object-fit: contain;
    }
    ._1234 {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        position: relative;
    }
    .frame-313477 {
        border-radius: 3px;
        border-style: solid;
        border-color: var(--wrap-wrap-emphasis, rgba(156, 249, 207, 0.1));
        border-width: 1px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .default {
        color: var(--color-emphasis, #9cf9cf);
        text-align: left;
        font-family: var(--label-xsmall-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--label-xsmall-font-size, 8px);
        line-height: var(--label-xsmall-line-height, 8px);
        font-weight: var(--label-xsmall-font-weight, 600);
        position: relative;
    }
    .trash-01 {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
        cursor: pointer;
    }
    .frame-296142 {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-313472 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .choose-other-payment-method {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        position: relative;
        width: 240px;
    }
    .chevron-right {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        position: relative;
        overflow: visible;
        rotate: 180deg;
        cursor: pointer;
    }
    .frame-29001,
    .frame-29001 * {
        box-sizing: border-box;
    }
    .frame-29001 {
        display: flex;
        flex-direction: row;
        gap: 20px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        padding: 0px 0px 19px 0px;
        border-bottom: 1px solid #373737;
    }
    .back-btn {
        background: var(--buttons-button-quaternary, rgba(166, 166, 166, 0.1));
        border-radius: 5px;
        padding: 4px 8px 4px 8px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 45px;
        height: 30px;
        position: relative;
    }
    .arrow-left {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        cursor: pointer;
    }
    .order-nr-321325-j {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--heading-3-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--heading-3-font-size, 16px);
        line-height: var(--heading-3-line-height, 24px);
        font-weight: var(--heading-3-font-weight, 600);
        position: relative;
        flex: 1;
    }
    .btn-xs-secondary {
        border: 1px solid var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-small-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .border {
        background: var(--salmon, #f7665f);
        border-radius: 5px;
        opacity: 1;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 371px;
        height: 48px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
        cursor: pointer;
    }
    .element {
        border: 1px solid #373737 !important;
        padding: 16px;
        border-radius: 5px;
        font-size: 14px !important;
        font-weight: 400 !important;
        color: red !important;
    }
    .element.typing {
        border: 1px solid #fff !important;
    }
`;
const PaymentMethodPanel = () => {
    const {
        setShowPaymentMethodPanel,
        setShowRightSettingsPanel,
        paymentPopupData,
        setPaymentLoading,
        stripeCardData,
        setStripeCardData,
        setSelectedPaymentType
    } = useContext(LayoutContext);
    const { BOTagAccountID, setUserPaymentMethods, setCheckoutPaymentData } = useContext(UserContext);

    const stripe = useStripe();
    const elements = useElements();

    const { isValidPaymentInfo } = paymentPopUptValidation({ type: paymentMethods.CARD, paymentPopupData, stripeCardData });

    const handleStates = async ({ res }) => {
        const paymentData = await processPaymentData({ responseData: res });

        const cards = await paymentData?.cardsData?.find(card => card?.isDefault === true);

        setUserPaymentMethods(paymentData);
        setSelectedPaymentType(paymentData.defaultPaymentMethod);
        setCheckoutPaymentData({
            cardNumber: cards?.cardNumber || "",
            cardHolder: cards?.cardHolderName || "",
            cardExpiration: cards?.cardExpDate || "",
            cardCVV: cards?.cardCVV || "",
            cardName: cards?.cardName || "",
            customerID: cards?.customer || "",
            paymentMethodID: cards?.paymentMethodID || ""
        });
    };

    const handleCreatePaymentMethod = async () => {
        try {
            if (!stripe || !elements) {
                return;
            }
            const cardElement = elements.getElement(CardElement);
            const { paymentMethod, error } = await stripe.createPaymentMethod({
                type: "card",
                card: cardElement
            });

            if (error) {
                return;
            }
            const res = await Library.makePostRequest(
                "createUserPaymentMethod",
                {
                    accountId: BOTagAccountID || "",
                    paymentMethodId: paymentMethod.id || "",
                    name: paymentPopupData?.nameOnCard || ""
                },
                false,
                setPaymentLoading
            );
            const success = await res?.data?.status;

            if (success) {
                setStripeCardData({
                    isCardNumber: false,
                    isCardExpData: false,
                    isCardCvv: false,
                    isComplete: false
                });
            }

            handleStates({ res });
        } catch (error) {}
    };

    return (
        <Styles style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <div className="frame-29001">
                <div className="back-btn cursor-pointer" onClick={() => setShowPaymentMethodPanel(false)}>
                    <img className="arrow-left" src={ArrowBack} alt="" />
                </div>
                <div className="order-nr-321325-j">Payment method</div>
                <div
                    className="btn-xs-secondary cursor-pointer"
                    onClick={() => {
                        setShowPaymentMethodPanel(false);
                        setShowRightSettingsPanel(false);
                    }}>
                    <div className="button">Close</div>
                </div>
            </div>

            <div className="frame-313515">
                <div className="frame-1000011190">
                    <div className="frame-1000011176">
                        <div className="add-credit-or-debit-card">Add credit or debit card</div>
                    </div>
                </div>
                <StripeInputs />
                <div
                    className={`btn-lg-solid ${isValidPaymentInfo && "border"}`}
                    style={{ pointerEvents: !isValidPaymentInfo && "none" }}
                    onClick={handleCreatePaymentMethod}>
                    <div className="frame-29590">
                        <img className="plus" src={plus} alt="" />
                        <div className="button">Add new card</div>
                    </div>
                </div>
                <div className="frame-1000011192">
                    <div className="default-payment-method">Default payment method</div>
                    <DefaultPaymentMethods handleStates={handleStates} />
                </div>
            </div>
        </Styles>
    );
};

export default PaymentMethodPanel;

const DefaultPaymentMethods = ({ handleStates = () => {} }) => {
    const { BOTagAccountID, userPaymentMethods } = useContext(UserContext);
    const { setPaymentLoading } = useContext(LayoutContext);
    const [showPaymentMethods, setShowPaymentMethods] = useState(false);

    const handleDeletePaymentMethod = async deleteItem => {
        try {
            const paymentMethodId = deleteItem?.id;
            const res = await Library.makePostRequest(
                "deleteUserPaymentMethod",
                {
                    paymentMethodType: paymentMethods.CARD,
                    accountId: BOTagAccountID,
                    paymentMethodId
                },
                false,
                setPaymentLoading
            );

            handleStates({ res });
        } catch (error) {}
    };

    const handleCardDefaultMethod = async item => {
        try {
            const paymentMethodId = item?.id;
            const res = await Library.makePostRequest(
                "updateUserDefaultPaymentMethod",
                {
                    paymentMethodType: paymentMethods.CARD || "",
                    accountId: BOTagAccountID || "",
                    paymentMethodId
                },

                false,
                setPaymentLoading
            );

            handleStates({ res });
        } catch (error) {}
    };

    return (
        <div className="frame-1000011193">
            <PaymentMethodList
                userPaymentMethods={userPaymentMethods}
                handleDeletePaymentMethod={handleDeletePaymentMethod}
                handleCardDefaultMethod={handleCardDefaultMethod}
                handleStates={handleStates}
            />

            {showPaymentMethods ? (
                <PaymentMethodsComponent setShowPaymentMethods={setShowPaymentMethods} handleStates={handleStates} />
            ) : (
                <div className="location-indicator">
                    <div className="frame-296142">
                        <div className="frame-313472">
                            <div className="choose-other-payment-method">Choose other payment method</div>
                        </div>
                        <img className="chevron-right" src={Vector} alt="" onClick={() => setShowPaymentMethods(true)} />
                    </div>
                </div>
            )}
        </div>
    );
};

const PaymentMethodList = ({
    userPaymentMethods = {},
    handleDeletePaymentMethod = () => {},
    handleCardDefaultMethod = () => {},
    handleStates = () => {}
}) => {
    const defaultPaymentMethod = userPaymentMethods?.defaultPaymentMethod;
    return (
        <>
            {userPaymentMethods?.cardsData?.map((item, index) => (
                <div className="frame-313477" key={index}>
                    <div className="frame-29614">
                        <div className="frame-1000011189">
                            {item?.card?.brand === cardType.VISA && <img className="group-1000011163" src={Visa} alt="" />}
                            {item?.card?.brand === cardType.MASTERCARD && <img className="group-1000011163" src={MasterCard} alt="" />}
                            <div className="_1234">****{item?.card?.last4}</div>
                            {item?.isDefault && userPaymentMethods?.defaultPaymentMethod === paymentMethods.CARD ? (
                                <div className="default">Default</div>
                            ) : (
                                <div
                                    class="btn-xs-secondary cursor-pointer"
                                    onClick={() => {
                                        handleCardDefaultMethod(item);
                                    }}>
                                    <div class="button">Set as default</div>
                                </div>
                            )}
                        </div>

                        <img className="trash-01" src={deleteIcon} alt="" onClick={() => handleDeletePaymentMethod(item)} />
                    </div>
                </div>
            ))}
            {defaultPaymentMethod !== paymentMethods.CARD && (
                <OtherDefaultPaymentMethods defaultPaymentMethod={defaultPaymentMethod} handleStates={handleStates} />
            )}
        </>
    );
};

const OtherDefaultPaymentMethods = ({ defaultPaymentMethod, handleStates = () => {} }) => {
    const { BOTagAccountID } = useContext(UserContext);
    const { setPaymentLoading } = useContext(LayoutContext);

    if (
        defaultPaymentMethod !== paymentMethods.APPLE_PAY &&
        defaultPaymentMethod !== paymentMethods.GOOGLE_PAY &&
        defaultPaymentMethod !== paymentMethods.KLARNA_PAY
    ) {
        return;
    }

    const imageDetails = {
        imageSource: "",
        name: ""
    };
    if (defaultPaymentMethod === paymentMethods.APPLE_PAY) {
        imageDetails.imageSource = applePay;
        imageDetails.name = paymentTypeNames.APPLE_PAY;
    } else if (defaultPaymentMethod === paymentMethods.GOOGLE_PAY) {
        imageDetails.imageSource = googlePay;
        imageDetails.name = paymentTypeNames.GOOGLE_PAY;
    } else if (defaultPaymentMethod === paymentMethods.KLARNA_PAY) {
        imageDetails.imageSource = klarna;
        imageDetails.name = paymentTypeNames.KLARNA_PAY;
    }

    const handleDeletePaymentMethod = async () => {
        try {
            const res = await Library.makePostRequest(
                "deleteUserPaymentMethod",
                {
                    paymentMethodType: defaultPaymentMethod,
                    accountId: BOTagAccountID
                },
                false,
                setPaymentLoading
            );
            handleStates({ res });
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="frame-313477">
            <div className="frame-29614">
                <div className="frame-1000011189">
                    <img className="group-1000011163" src={imageDetails.imageSource} alt="" />

                    <div className="_1234">{imageDetails.name}</div>
                    <div className="default">Default</div>
                </div>
                <img className="trash-01" src={deleteIcon} alt="" onClick={handleDeletePaymentMethod} />
            </div>
        </div>
    );
};
